import { withStyles } from '@material-ui/core/styles';
import styles from './CardCollapsed.styles';
import CardCollapsed from './CardCollapsed';

export default withStyles(styles)(CardCollapsed);
